import { useCallback } from "react";

import { useQuery } from "hooks";

export function useMeetingFormOptions() {
  const queryFactory = useCallback(() => {
    const query = `query getMeetingFormOptions {
                    crmLists(listType: CRM_USER, isDeleted: false) {
                      edges {
                        node {
                          id
                          name
                        }
                      }
                    }
                    hub {
                        meetingDateTypes {
                            edges {
                                node {
                                    id
                                    name
                                }
                            }
                        }
                    }
                }`;

    const resolver = ({ data }) => {
      return {
        users: data.crmLists.edges.map(({ node }) => {
          return node;
        }),
        meetingTypes: data.hub.meetingDateTypes.edges.map(({ node }) => {
          return node;
        }),
      };
    };

    return { query, resolver };
  }, []);

  const query = useQuery(queryFactory, { cached: true });

  return { options: query.data, isLoadingOptions: query.loading };
}

export default useMeetingFormOptions;
